const state = {
  selecedtProcess: {}
}

const mutations = {
  selelctProcess (state: any, info: Object) {
    state.selecedtProcess = info;
  }
}

const getters = {
  getSelectedProcess (state:any) {
    return state.selecedtProcess
  }
}

export default {
  namespaced: true, 
  state ,
  mutations , 
  getters ,
} ; 